import en from "./en.svg";
import it from "./it.svg";
import ar from "./ar.svg";
import es from "./es.svg";
import fr from "./fr.svg";
import pt from "./pt.svg";
import zh from "./zh.svg"; // Chinese zh-CN
import ja from "./ja.svg"; // Japanese ja-JP

// these flags come from https://flagicons.lipis.dev/

export default {
  en,
  it,
  ar,
  es,
  fr,
  pt,
  zh,
  ja
};
